import { render } from "./purchase-table.vue?vue&type=template&id=697c1bc2"
import script from "./purchase-table.vue?vue&type=script&lang=js"
export * from "./purchase-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__